import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Box, CircularProgress, Paper, Tab, Tabs, WithStyles } from "@material-ui/core";
import { styles } from "./ManageUseCasesView.styles";
import * as UseCasesAction from "../../../../stores/useCases/UseCasesAction";
import { useTranslation } from "react-i18next";
import { selectRequesting } from "../../../../selectors/requesting/RequestingSelector";
import { Breadcrumbs } from "../../../components/Breadcrumbs/Breadcrumbs";
import { CenteredContainer } from "../../../components/CenteredContainer/CenteredContainer";
import { ManageUseCasesCategoriesView } from "./ManageUseCasesCategories";
import { ManageUseCasesView } from "./ManageUseCasesView";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`download-centre-tabpanel-${index}`}
            aria-labelledby={`download-centre-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={0}>{children}</Box>}
        </div>
    );
}

export interface IManageUseCasesTabsViewProps extends WithStyles<typeof styles> {}

const ManageUseCasesTabsViewPure: React.FunctionComponent<IManageUseCasesTabsViewProps> = ({
    classes
}: IManageUseCasesTabsViewProps) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(UseCasesAction.requestAllUseCases());
        dispatch(UseCasesAction.requestAllCategories());
    }, [dispatch]);

    const [selectedTab, setSelectedTab] = React.useState(0);

    const isRequesting = useSelector(state =>
        selectRequesting(state, [UseCasesAction.REQUEST_ALL_USE_CASES, UseCasesAction.REQUEST_ALL_CATEGORIES])
    );

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
    };

    const tabs = [
        {
            title: "Use cases",
            view: <ManageUseCasesView />
        },
        {
            title: "Use cases categories",
            view: <ManageUseCasesCategoriesView />
        }
    ];

    return (
        <CenteredContainer>
            <Breadcrumbs items={[{ title: t("admin.adminPanel"), href: "/admin" }, { title: "Manage Use cases" }]} />
            <div className={classes.gap}></div>
            {isRequesting ? (
                <div className={classes.center}>
                    <CircularProgress color="inherit" className={classes.center} />
                </div>
            ) : (
                <Paper square>
                    <Tabs value={selectedTab} indicatorColor="primary" textColor="primary" onChange={handleTabChange}>
                        {tabs.map((tabs, index) => (
                            <Tab key={tabs.title} label={tabs.title} />
                        ))}
                    </Tabs>
                    {tabs.map((tab, index) => {
                        return (
                            <TabPanel value={selectedTab} key={index} index={index}>
                                {tab.view}
                            </TabPanel>
                        );
                    })}
                </Paper>
            )}
        </CenteredContainer>
    );
};

export const ManageUseCasesTabsView = withStyles(styles)(ManageUseCasesTabsViewPure);
